
__webpack_require__.debugRequireIds = {
	"-!./debug-require.cjs": 2800,
	"-!jquery": 49949,
	"./debug-require.cjs": 13732,
	"./src/base_page_params.ts": 26087,
	"./src/blueslip.ts": 50489,
	"./src/blueslip_stacktrace.ts": 49437,
	"./src/bot_types.ts": 70176,
	"./src/bundles/common.ts": 6400,
	"./src/csrf.ts": 1933,
	"./src/portico/communities.ts": 9357,
	"./src/portico/google-analytics.ts": 9900,
	"./src/portico/portico_modals.ts": 23437,
	"./src/portico/tippyjs.ts": 95225,
	"./src/realm_user_settings_defaults.ts": 64199,
	"./src/sentry.ts": 21440,
	"./src/state_data.ts": 80645,
	"./src/stream_types.ts": 76113,
	"./src/types.ts": 14550,
	"./src/user_settings.ts": 50526,
	"./src/user_status_types.ts": 12623,
	"./styles/portico/integrations.css": 80252,
	"./styles/portico/legacy_landing_page.css": 94468,
	"./templates/blueslip_stacktrace.hbs": 24075,
	"core-js/modules/es.array.push.js": 64755,
	"core-js/modules/es.iterator.constructor.js": 94178,
	"core-js/modules/es.iterator.find.js": 58471,
	"core-js/modules/es.iterator.map.js": 64792,
	"core-js/modules/es.json.stringify.js": 99811,
	"core-js/modules/esnext.json.parse.js": 22862,
	"core-js/modules/web.url-search-params.delete.js": 89584,
	"core-js/modules/web.url-search-params.has.js": 17535,
	"core-js/modules/web.url-search-params.size.js": 10418,
	"error-stack-parser": 69363,
	"ga-gtag": 78406,
	"handlebars/runtime.js": 81942,
	"jquery": 93576,
	"micromodal": 98476,
	"minimalistic-assert": 45185,
	"source-map": 68068,
	"stackframe": 36854,
	"stacktrace-gps": 14021,
	"tippy.js": 99947,
	"tippy.js/dist/tippy.css": 96773,
	"zod/mini": 49020
};